import { OEmbedInfo as OEmbed } from "../common/index.mjs";
import { Element } from "../Element.mjs";
import { isEnum, isNonEmptyString, isUuid } from "../validation/index.mjs";
export var EmbedNode;

(function (EmbedNode) {
  EmbedNode.TYPE = 'embed';
  var Layout;

  (function (Layout) {
    Layout["CONTAINED"] = "contained";
    Layout["EXPANDED"] = "expanded";
    Layout["FULL_WIDTH"] = "full-width";
  })(Layout = EmbedNode.Layout || (EmbedNode.Layout = {}));

  EmbedNode.OEmbedInfo = OEmbed;

  function isEmbedNode(value) {
    return Element.isElement(value, EmbedNode.TYPE);
  }

  EmbedNode.isEmbedNode = isEmbedNode;

  function validateEmbedNode(value) {
    var isValid = isEmbedNode(value) && isNonEmptyString(value.url) && isEnum(value.layout, Layout) && isUuid(value.uuid) && OEmbed.isOEmbedInfo(value.oembed);
    return isValid ? value : null;
  }

  EmbedNode.validateEmbedNode = validateEmbedNode;
})(EmbedNode || (EmbedNode = {}));